import type {DeadlineCountdownType} from '../../features/recruitingInfo/usecase/getDeadlineCountdown';

type RecruitmentCardGtmContentArgs = {
  recruitmentItemId: number;
  deadlineCountdown: DeadlineCountdownType;
};

export const buildRecruitmentCardGtmContent = ({
  recruitmentItemId,
  deadlineCountdown,
}: RecruitmentCardGtmContentArgs): string =>
  JSON.stringify({
    recruitment_item_id: recruitmentItemId,
    deadline_countdown: deadlineCountdown,
  });
